module.exports = __webpack_public_path__ + "static/img/p1.a7c9d94f.png";